var React = require('react');

var GameStatus = React.createClass({
    render: function(){

        var broadcasts = this.props.broadcasts || {};
        var broadcastLink;
        var status = [
            <span key="game.date" className="game-date">{this.props.status == 'pregame' ? this.props.date : ''}</span>,
            <span key="game.time" className="game-time">{(this.props.time || '').toUpperCase()}</span>,
            <span key="game.play" className="game-play"></span>
        ];

        if(broadcasts.url && broadcasts.name){
            broadcastLink = (
                <span className="network">
                    <a href={broadcasts.url} className={broadcasts.external === true ? "external" : ''}>{broadcasts.name}</a>
                </span>
            );
        }
        
        if(this.props.anchor){
            status = (
                <a data-route="false" href={this.props.anchor}>
                    {status}
                </a>
            );
        }

        return (
            <div className="game-status">
                {broadcastLink}
                {status}
            </div>
        );
    }
});

var GameHeader = React.createClass({
    render: function(){
        var text = this.props.text;
        var details = (
            <div className="game-details header">
                {text}
            </div>
        );

        return text ? details : null;
    }
});

var Competitor = React.createClass({
    render: function(){

        var team = this.props.team;
        var isHomeTeam = this.props.team.home;
        var scoreContainer = (
            <div key="score.container" className="score-container">
                <span className={"score icon-font-" + (!isHomeTeam ? 'before' : 'after')}>{this.props.score}</span>
            </div>
        );
        var teamForm = '';
        var teamInfoStyle = {};
        
        if(team.form && this.props.status === 'pregame'){
            teamForm = "Form: " + team.form;
        }else{
            teamInfoStyle = { top : '27px' };
        }
        
        var teamContainer = [
            <a href={team.url || '#'} key="team.container" className="team-container">
                <div className="logo">
                    <picture>
                        <source srcSet={team.logo}/>
                        <img data-default-src={team.logo} className="team-logo" src={team.logo}/>
                    </picture>
                </div>
                <div className="team-info" style={teamInfoStyle}>
                    <span className="rank"></span>
                    <span className="team-name">
                        <span className="long-name">{team.name}</span>
                        <span className="short-name">{team.name}</span>
                        <span className="abbrev">{team.abbreviation}</span>
                    </span>
                    <span className="record">{teamForm}</span>
                </div>
            </a>
        ];

        if(isHomeTeam){
            teamContainer.push(scoreContainer);
        }else{
            teamContainer.unshift(scoreContainer);
        }

        return (
            <div className={"team " + (!isHomeTeam ? 'home' : 'away')}>
                <div className="content">
                    {teamContainer}
                </div>
            </div>
        );
    }
});



var GameStrip = React.createClass({
    render : function(){
        var classMap = {
            'pregame' : 'pre',
            'live' : 'live',
            'final' : 'post'
        };
        var headerClasses = ['game-strip'];

        headerClasses.push(this.props.sport || 'rugby', this.props.winnerClass || '', classMap[this.props.gameStatus] || '');

        return (
            <header style={this.props.styles} className={headerClasses.join(' ')}>
                <GameHeader text={this.props.heading} />
                <div className="competitors sm-score">
                    <Competitor team={this.props.teams.home} score={this.props.scores.home} status={this.props.gameStatus} />
                    <GameStatus broadcasts={this.props.broadcasts} status={this.props.gameStatus} date={this.props.formattedDate} time={this.props.time} />
                    <Competitor team={this.props.teams.away} score={this.props.scores.away} status={this.props.gameStatus} />
                </div>
            </header>
        );
    }
});

module.exports = GameStrip;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/scoreboard/game-strip/GameStrip.jsx
 **/